<button type="button" class="mat-button-close" mat-icon-button (click)="cancel()">
    <i-feather name="X"></i-feather>
</button>

@if (data.translate) {
    @if (data.title) {
        <h2 mat-dialog-title>{{ data.title | translate }}</h2>
    }
    @if (!data.title) {
        <h2 mat-dialog-title>{{ 'shared.confirmation' | translate }}</h2>
    }
}
@if (data.title && !data.translate) {
    <h2 mat-dialog-title>{{ data.title }}</h2>
}

<mat-dialog-content>
    @if (data.message && data.translate) {
        <span [innerHTML]="data.message | translate"></span>
    }
    @if (data.message && !data.translate) {
        <span [innerHTML]="data.message"></span>
    }
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="cancel()">{{ 'shared.cancel' | translate }}</button>
    <button mat-flat-button (click)="confirm()">{{ 'shared.confirm' | translate }}</button>
</mat-dialog-actions>
